module.exports = __webpack_public_path__ + "img/旋转3.11f70283.svg";